/**
 * RegularListPresenter
 * --
 */
import React, { useState } from 'react';
import { Content, Title, Row, Col, ModalLayout } from 'components';
import { Divider, Empty, Spin } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import { ExpandableContainer, Table, Statistic } from 'components';
// import { Button, Input, Select } from 'antd';

import OrderFilter from './components/OrderFilter';
import OrderSummaryStatics from '../OrderList/components/OrderSummaryStatics';

import OrderData from './components/OrderData';
import ShopInformationList from '../OrderList/components/ShopInformationList';

const RegularListPresenter = ({
  permission,
  loading,
  searchFilter,
  onSearch,
  orderList,
  currentShop,
  onChange,
  setCurrentShop,
  onResetFilter,
  onSaveDeliveryInfo,
  shipping_type,
  onCancel,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // 결제완료 데이터
  const completedData = orderList.filter(
    (o) => o.payment_state === 'COMPLETED'
  );
  // 환불/취소 데이터
  const refundedData = orderList.filter(
    (o) => o.purchase_status === 'REFUNDED'
  );
  const refundCount = refundedData.length ?? 0;
  const refundPrice =
    refundedData.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
  const totalCount = orderList.length ?? 0;
  const totalPrice =
    orderList.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
  const totalDiscount =
    completedData.reduce((acc, cur) => acc + cur.final_discount ?? 0, 0) ?? 0;
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 12 }}>
            {/* 배송 목록 */}
            렌탈 배송 관리
          </Title>

          {/* 요약 */}
          <OrderFilter
            onChange={onChange}
            searchFilter={searchFilter}
            onSearch={onSearch}
            onResetFilter={onResetFilter}
          />
          {/* 요약 */}
          <OrderSummaryStatics
            totalCount={totalCount ?? 0}
            totalPrice={totalPrice ?? 0}
            totalDiscount={totalDiscount ?? 0}
            refundPrice={refundPrice ?? 0}
            refundCount={refundCount ?? 0}
          />
          {/* 요약 */}
          <Spin spinning={loading}>
            <Row style={{ minHeight: '50vh' }}>
              {/* === 업체목록 === */}
              {permission === 'ADMIN' && (
                <Col x={3}>
                  <ShopInformationList onChange={setCurrentShop} />
                </Col>
              )}
              {/* === Data === */}
              <Col
                x={permission === 'ADMIN' ? 21 : 24}
                style={{
                  borderLeft: '1px solid #EBEBEB',
                }}
              >
                <OrderData
                  orderList={orderList}
                  onSaveDeliveryInfo={onSaveDeliveryInfo}
                  type={shipping_type}
                  onReload={onSearch}
                  onCancel={onCancel}
                />
              </Col>
            </Row>
          </Spin>

          <Divider />
        </Col>
      </Row>
    </Content>
  );
};

export default RegularListPresenter;
